import { render, staticRenderFns } from "./AddBulkUploadTreeImagesPopup.vue?vue&type=template&id=b97cc8e8"
import script from "./AddBulkUploadTreeImagesPopup.vue?vue&type=script&lang=js"
export * from "./AddBulkUploadTreeImagesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports